var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsDateString, IsNumber, IsString, IsUUID } from 'class-validator';
export class CustomFormElementAnswerLiteDto {
    id;
    createdAt;
    updatedAt;
    answer;
    index;
    customFormElementId;
    customFormAnswerId;
}
__decorate([
    IsUUID(),
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CustomFormElementAnswerLiteDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], CustomFormElementAnswerLiteDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], CustomFormElementAnswerLiteDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", Object)
], CustomFormElementAnswerLiteDto.prototype, "answer", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CustomFormElementAnswerLiteDto.prototype, "index", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], CustomFormElementAnswerLiteDto.prototype, "customFormElementId", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], CustomFormElementAnswerLiteDto.prototype, "customFormAnswerId", void 0);
//# sourceMappingURL=custom-form-element-answer.lite.dto.js.map